import Vue from 'vue';

import _ from 'lodash';
import SurveyApi from '../../../api/SurveyApi';

const QUESTION_TYPES = {
  TEXT: 'text',
  STAR_RATING: 'star-rating',
};

const questions = [
  {
    name: 'ActivationStarRank',
    text: 'איך היה לקבל את התזרים?',
    type: QUESTION_TYPES.STAR_RATING,
    options: [1, 2, 3, 4, 5],
    answer: null,
    required: true,
    page: 1,
  },
  {
    name: 'ActivationOpenQuestion',
    text: 'נשמח לשמוע עוד על רגע קבלת התזרים:',
    type: QUESTION_TYPES.TEXT,
    answer: null,
    required: false,
    page: 1,

  },
  {
    name: 'ActivationAccuracyRank',
    text: '"התזרים משקף נכון את ההוצאות וההכנסות שלי"',
    type: QUESTION_TYPES.STAR_RATING,
    options: [1, 2, 3, 4, 5],
    answer: null,
    required: true,
    page: 2,
  },
  {
    name: 'ActivationUnderstandingRank',
    text: '"התזרים מובן לי"',
    type: QUESTION_TYPES.STAR_RATING,
    options: [1, 2, 3, 4, 5],
    answer: null,
    required: true,
    page: 2,
  },
  {
    name: 'ActivationActionabilityRank',
    text: '"התזרים יעזור לי לדעת כמה כסף אפשר להוציא ביום יום״',
    type: QUESTION_TYPES.STAR_RATING,
    options: [1, 2, 3, 4, 5],
    answer: null,
    required: true,
    page: 2,
  },
];

const state = {
  firstPageCompleted: false,
  surveyCompleted: false,
  questionTypes: QUESTION_TYPES,
  questions,
};

const getters = {
};

const actions = {
  setAnswer({ commit }, { questionName, answer }) {
    commit('setAnswer', { questionName, answer });
  },
  async completeFirstPage({ commit }) {
    commit('setFirstPageCompleted', true);
  },
  async saveAnswers({ commit, state }) {
    commit('setSurveyCompleted', true);
    await SurveyApi.saveActivationSurveyAnswers({ answers: _.map(state.questions, _extractAnswer) });
  },
};

const mutations = {
  setFirstPageCompleted(state, completed) {
    state.firstPageCompleted = completed;
  },
  setSurveyCompleted(state, completed) {
    state.surveyCompleted = completed;
  },
  setAnswer(state, { questionName, answer }) {
    const questionIndex = state.questions.findIndex(question => question.name === questionName);
    Vue.set(state.questions[questionIndex], 'answer', answer);
  },
};

function _extractAnswer(question) {
  return {
    name: question.name,
    answer: `${question.answer}`,
  };
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
